type Props = {
  /** @param className is for positioning the badge on a parent. Avoid using for styling. */
  className?: string;
  content?: string | number; // ignored when the 'type' is set to 'warning'.
  type: 'warning' | 'notification' | 'default';
};

const typeClasses = {
  default: 'bg-badge-default text-type-secondary',
  notification: 'bg-badge-notification text-type-secondary',
  warning:
    'relative bg-badge-warning before:absolute before:h-1 before:w-1 before:rounded-full before:bg-background-primary',
};

export default function Badge(props: Props) {
  const children = props.type !== 'warning' && props.content !== '' ? props.content : null;

  return (
    <div className={props.className}>
      <div
        aria-hidden
        className={[
          'flex h-5 min-w-5 max-w-max items-center justify-center rounded-full px-1 type-body3',
          typeClasses[props.type],
        ].join(' ')}
        data-cy="badge"
      >
        {children}
      </div>
    </div>
  );
}
